import React from "react";
import ReactDOM from "react-dom";
import scriptLoader from "react-async-script-loader";
import { Card, Button } from 'react-bootstrap'
import { ONE_TIME_PAYMENT, 
    ONE_TIME_TITLE, CURRENCY, 
    PLAN_ID, IS_RECURRING,
    IS_NOT_RECURRING,
    PAYMENT_TYPE_LEAGUES_PASS,
    LEAGUE_PASS_PAYMENT,
    LEAGUE_PASS_TITLE } from "../../../../utils/constants";
import { PAYPAL_CLIENT_ID } from "../../../../config/settings";



let PayPalButton = null;
class PaypalButton extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showButtons: false,
            loading: true,
            transactionDetails: null
        };

        window.React = React;
        window.ReactDOM = ReactDOM;
    }

    componentDidMount() {
        const { isScriptLoaded, isScriptLoadSucceed } = this.props;

        if (isScriptLoaded && isScriptLoadSucceed) {
            PayPalButton = window.paypal.Buttons.driver("react", { React, ReactDOM });
            this.setState({ loading: false, showButtons: true });
        }
    }

    componentWillReceiveProps(nextProps) {
        const { isScriptLoaded, isScriptLoadSucceed } = nextProps;

        const scriptJustLoaded =
            !this.state.showButtons && !this.props.isScriptLoaded && isScriptLoaded;

        if (scriptJustLoaded) {
            if (isScriptLoadSucceed) {
                PayPalButton = window.paypal.Buttons.driver("react", {
                    React,
                    ReactDOM
                });
                this.setState({ loading: false, showButtons: true });
            }
        }
    }
    createOrder = (data, actions) => {
        return actions.order.create({
            purchase_units: [
                {
                    description: this.props.paymentType === PAYMENT_TYPE_LEAGUES_PASS ? LEAGUE_PASS_TITLE : ONE_TIME_TITLE,
                    amount: {
                        currency_code: CURRENCY,
                        value: this.props.paymentType === PAYMENT_TYPE_LEAGUES_PASS ? LEAGUE_PASS_PAYMENT : ONE_TIME_PAYMENT
                    }
                }
            ]
        });
    };

    onApprove = (data, actions) => {
        const paymentData = {
            payerID: data.payerID,
            transactionCode: data.orderID,
            isRecurring: IS_NOT_RECURRING
        };
        actions.order.capture().then(details => {
            this.setState({ transactionDetails: details, showButtons: false }, () => {
                this.props.handleSuccess(paymentData)
            })
        });
    };

    onApproveSubscription = (data, actions) => {
        const paymentData = {
            payerID: data.payerID,
            transactionCode: data.subscriptionID,
            isRecurring: IS_RECURRING
        };

        actions.subscription.get().then((details) => {
            this.setState({ transactionDetails: details, showButtons: false }, () => {
                this.props.handleSuccess(paymentData)
            })
        })
    }

    render() {
        const { showButtons } = this.state;
        return (
            <div className="main">
                {showButtons && (
                    <div>
                        <Card>
                            <text className={"paypal-text-title"} >One-time Payment</text>
                            <div style={{ marginTop: 12 }}>
                                <PayPalButton
                                    createOrder={(data, actions) => this.createOrder(data, actions)}
                                    onApprove={(data, actions) => this.onApprove(data, actions)}
                                />
                            </div>
                        </Card>
                        {/* {!this.props.reactivate &&
                            <Card>
                                <text className={"paypal-text-title"}>Recurring Subscription</text>
                                <div style={{ marginTop: 12 }}>
                                    <PayPalButton
                                        createSubscription={(data, actions) => {
                                            return actions.subscription.create({
                                                'plan_id': PLAN_ID
                                            })
                                        }}
                                        onApprove={(data, actions) => { this.onApproveSubscription(data, actions) }}
                                        style={{
                                            shape: 'rect',
                                            color: 'blue',
                                            layout: 'vertical',
                                            label: 'subscribe',
                                        }}
                                    />
                                </div>
                            </Card>
                        } */}

                    </div>)
                }
            </div>
        );
    }
}


export default scriptLoader(`https://www.paypal.com/sdk/js?client-id=${PAYPAL_CLIENT_ID}&vault=true&currency=PHP&locale=en_PH`)(PaypalButton);